import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import ApiFactory from 'Api/ApiFactory';
import { Callbacks } from 'jquery';

@Component({
    template: '#re-captcha-template'
})
export default class ReCaptchaComponent extends ABaseComponent {
    recaptchaResponse : string = null;
    
    private _isInitialized: boolean = false;
    
    async created() {
        // For more options see below
        Vue.use(VueReCaptcha, { siteKey: ApiFactory.getReCaptchaToken()});
        
        // test
        await this.$recaptchaLoaded();
        console.log('debug - recaptcha is loaded!');
    }
    
    public async validate(form: HTMLFormElement){
        if(!this._isInitialized){
            form.append(this.$el);
            this._isInitialized = true;
        }
        //IMPORTANT NOTE: we needs to refresh the token key everytime as read once will clear it on 3.party
        //ex. if server return error once the token has to be different next time
        await this.recaptcha(form);
    }
    
    
    private async recaptcha(form: HTMLFormElement) {
        
        const token = await this.$recaptcha(form.id);
        console.log('token is received!');
        
        this.recaptchaResponse = token;
    }
}
Vue.component('re-captcha', ReCaptchaComponent);